export default {
  heading: 'PT Serif, serif',
  body: 'Montserrat, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'PT Serif, serif',
  googleFonts: ['Montserrat:100,200,300,400,500,600,700,800,900', 'PT Serif:400,500,600,700,800,900']
  // customFamilies: [''],
  // customUrls: [''],
}
